var map = {
	"./ fundingCenter.js": 131,
	"./audit.js": 6102,
	"./commodity.js": 9699,
	"./dashboard.js": 4404,
	"./dataCenter.js": 1784,
	"./finance.js": 7003,
	"./marketing.js": 5377,
	"./member.js": 8722,
	"./merchantOperationsCenter.js": 2999,
	"./merchantStore.js": 7229,
	"./order.js": 8728,
	"./paysuccess.js": 421,
	"./permission.js": 5285,
	"./platform.js": 5554,
	"./platformstore.js": 5594,
	"./setting.js": 82,
	"./shop.js": 2870,
	"./statistics.js": 3777,
	"./workOrders.js": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;